import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList, addData } from "../../helpers/fackBackend_Helper";

function* SimSwapResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/API/V1/Swap/SimSwap", data);
    if (response?.statusCode == 1200) {
      yield put(actions.simSwapSuccess(response?.message));
    } else {
      yield put(actions.simSwapError(response?.message, response?.data));
    }
  } catch (error) {
    yield put(actions.simSwapError(error));
  }
}

function* MDNSwapResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/API/V1/Swap/MSISDNSwap", data);
    if (response?.statusCode == 1200) {
      yield put(actions.mdnswapSuccess(response?.message));
    } else {
      yield put(actions.mdnswapError(response?.message, response?.data));
    }
  } catch (error) {
    yield put(actions.mdnswapError(error));
  }
}


export default function* rootSaga() {
  yield all([takeEvery(actions.SIM_SWAP, SimSwapResponse)]);
  yield all([takeEvery(actions.MDN_SWAP, MDNSwapResponse)]);

}
